import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals.ts';
import { register } from './registerServiceWorker';
import { initFaro } from './lib/faro.ts';

initFaro();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar service worker para PWA
register({
  onSuccess: () => {
    console.log('App está pronto para uso offline!');
  },
  onUpdate: () => {
    console.log('Nova versão disponível! Recarregue a página.');
  }
});

reportWebVitals();